import { useQuery } from '@tanstack/react-query';
import { marketService } from '@services/marketService';

export const useMarketData = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['market-data'],
    queryFn: marketService.getData,
    staleTime: 5 * 60 * 1000,      // 5 minutos
    refetchInterval: 5 * 60 * 1000, // Atualiza a cada 5 minutos
    retry: 1,
  });

  return {
    quotes: Array.isArray(data) ? data : [],
    isLoading,
    isError: !!error,
  };
};

export default useMarketData;
